import PropTypes from 'prop-types';
import React from 'react';

function BlueTitleRow({
  title,
  right = undefined,
  noLine = false,
  style=undefined,
}: {
  title?: React.ReactNode|string,
  right?: React.ReactNode|string|null|undefined,
  noLine?: boolean,
  style?: React.CSSProperties|undefined,
}) {
  const baseStyle = style || {};

  return (
    <div className={noLine ? 'ifms-blue-title-row-noline' : 'ifms-blue-title-row'}>
      <div style={baseStyle} className={ noLine ? 'ifms-blue-title-row-title-noline' : 'ifms-blue-title-row-title'}>
        {title}
      </div>
      {!!right &&
        <>
          <div className="ifms-blue-title-row-title-right">
            {right}
          </div>
          <div className="clearfix"></div>
        </>
      }
    </div>
  );
}

BlueTitleRow.defaultProps = {
  title: '',
  noLine: false,
};

BlueTitleRow.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  right: PropTypes.node,
  noLine: PropTypes.bool.isRequired,
};


export default React.memo(BlueTitleRow);
